import {
  Box,
  Button,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { RouterLink } from "components/router-link";
import UnauthorizedImage from "assets/images/401.svg";

interface CustomProps {
  permissionDenied?: boolean;
}

const Unauthorized = (props: CustomProps) => {
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const getBody = () => {
    return (
      /*
       * A `div`, not a `main#main-content`: this component renders inside the
       * `<main id="main-content">` that `App` wraps protected routes in, so the
       * original markup produced a nested main landmark and a duplicate id
       * (WCAG 1.3.1 / 4.1.1).
       */
      <div tabIndex={-1} style={{ outline: "none" }}>
        <Stack
          sx={{
            backgroundColor: "white",
            height: "100vh",
          }}
          alignItems="center"
          justifyContent="center"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 2,
            }}
          >
            <Box
              component="img"
              src={UnauthorizedImage}
              alt={props.permissionDenied ? "Permission denied illustration" : "Unauthorized access illustration"}
              sx={{
                height: "auto",
                maxWidth: "100%",
                width: 350,
              }}
            />
          </Box>
          {/* `component` is pinned so the heading level does not change with
              the viewport — `variant` still drives the size (WCAG 1.3.1). */}
          <Typography
            align="center"
            component="h1"
            variant={mdUp ? "h1" : "h4"}
          >
            {props.permissionDenied
              ? "Permission required"
              : "Authorization required"}
          </Typography>
          <Typography align="center" color="text.secondary" sx={{ mt: 2, mx: 2 }}>
            {props.permissionDenied
              ? "You don't have necessary permissions to view this page. Please contact your account administrator."
              : "You either tried some shady route or you came here by mistake Whichever it is, try using the navigation."}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Button variant="contained" component={RouterLink} href={"/"}>
              Back to Home
            </Button>
          </Box>
        </Stack>
      </div>
    );
  };

  return getBody();
};

export default Unauthorized;
